<template>
  <div class="page-layout">
    <div class="page-content">
      <AppBreadcrumbs :items="breadcrumbItems" />
      <h1>Редактирование поездки</h1>

      <div v-if="loading" class="panel">
        <p class="empty-state">Загрузка...</p>
      </div>

      <TripForm
        v-else
        v-model:name="name"
        v-model:trip-date="tripDate"
        v-model:track-completion-id="trackCompletionId"
        v-model:body="body"
        v-model:pending-photos="pendingPhotos"
        v-model:companions="companions"
        v-model:is-public="isPublic"
        v-model:allow-comments="allowComments"
        :current-completion-id="currentCompletionId"
        :existing-photos="existingPhotos"
        photos-add-label="Добавить фотографии"
        :error="error"
        :submitting="submitting"
        :cancel-to="{ name: 'trip', params: { id: route.params.id } }"
        @submit="submit"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppBreadcrumbs from '../components/AppBreadcrumbs.vue'
import TripForm from '../components/TripForm.vue'
import { fetchTrip, updateTrip } from '../api/trips'

const route = useRoute()
const router = useRouter()

const loading = ref(true)
const name = ref('')
const tripDate = ref('')
const trackCompletionId = ref('')
const currentCompletionId = ref('')
const body = ref('')
const existingPhotos = ref([])
const pendingPhotos = ref([])
const companions = ref([])
const isPublic = ref(false)
const allowComments = ref(false)
const submitting = ref(false)
const error = ref('')

const breadcrumbItems = computed(() => [
  { label: 'Поездки', to: { name: 'trips-home' } },
  { label: name.value || 'Поездка', to: { name: 'trip', params: { id: route.params.id } } },
  { label: 'Редактирование' },
])

async function loadData() {
  loading.value = true
  error.value = ''
  try {
    const { data: trip } = await fetchTrip(route.params.id)
    name.value = trip.name
    tripDate.value = trip.trip_date
    trackCompletionId.value = trip.track_completion?.id ? String(trip.track_completion.id) : ''
    currentCompletionId.value = trackCompletionId.value
    body.value = trip.body || ''
    existingPhotos.value = trip.photos || []
    companions.value = trip.companions || []
    isPublic.value = trip.public
    allowComments.value = trip.allow_comments
  } catch {
    error.value = 'Не удалось загрузить поездку'
  } finally {
    loading.value = false
  }
}

async function submit() {
  submitting.value = true
  error.value = ''
  try {
    const { data } = await updateTrip(
      route.params.id,
      {
        name: name.value,
        trip_date: tripDate.value,
        body: body.value,
        track_completion_id: trackCompletionId.value || null,
        public: isPublic.value,
        allow_comments: allowComments.value,
        companion_user_ids: companions.value.map((user) => user.id),
      },
      pendingPhotos.value.map((photo) => photo.file)
    )
    router.push({ name: 'trip', params: { id: data.id } })
  } catch (err) {
    error.value = err.response?.data?.errors?.join(', ') || 'Не удалось сохранить поездку'
  } finally {
    submitting.value = false
  }
}

onMounted(loadData)
</script>
